import React from "react";
import { CommonTable, GenerateForm } from "../../../../../components";
import { actions } from "frequencyscreen_v_dbinder";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//import { AlertProps } from "../../../../../utils";
import { withAllContexts } from "../../../../../HOCs";

class OrderNature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openEditFrom: false,
      // saveloading: false,
      // edit_data: null
    };
    // this.saveForm = this.saveForm.bind(this)
    // this.handleEdit = this.handleEdit.bind(this)
    // this.handleCheckBox = this.handleCheckBox.bind(this)
  }
  componentDidMount() {
    const getdata = async () => {
      await this.props.ORDERNATUREREAD();
      //   await this.props.ORDERCATEGORYMASTER();
    };
    getdata();
  }
  handleCloseForm = () => {
    const { changeState } = this.props;
    changeState("open", false);
    this.setState({
      openEditFrom: false,
      edit_data: null,
    });
  };

  statusChange = async (e, values, index) => {
    let data = {
      code: values.code,
      description: values.short,
      status: e.target.checked,
      _key: values._key,
      id: values.id,
    };
    await this.props.UPDATEORDERNATURETABLESTATE({
      data,
    });
    await this.props.ORDERNATUREREAD();
    this.props.alert.setSnack("update");
    this.handleCloseForm();
  };

  handleEdit = (e, values, index) => {
    const { changeState } = this.props;
    changeState("open", true);
    changeState("openIndex", 1);
    let data = {
      // _key: values?._key,
      _key: values?.coding?.[0]?._key,
      short: values?.short,
      long: values?.long,
      code: values?.code,
      status: values?.status,
    };
    this.setState({
      ...this.state,
      edit_data: data,
    });
  };

  saveOrderNature = async (values) => {
    if (this.state.edit_data) {
      let data = {
        ordertype: values?.order_nature,
        shortdesc: values?.short_Description,
        longdesc: values?.long_Description,
        status: this.state.edit_data.status,
        _key: this.state.edit_data._key,
        code: values?.order_nature,
      };
      let edit_data = await this.props.UPDATESETORDERNATURETABLE({ data });
      if (edit_data?.payload?.data?.error) {
        this.props.alert.setSnack("error");
        return false;
      } else {
        this.props.alert.setSnack("update");
      }

      await this.props.ORDERNATUREREAD();
      this.setState({
        openEditFrom: false,
        edit_data: null,
      });
      this.handleCloseForm();
    } else {
      let data = {
        ordertype: values?.order_nature,
        shortdesc: values?.short_Description,
        longdesc: values?.long_Description,
        status: true,
      };
      let addnew = await this.props.INSERTORDERNATURETABLE({ data });
      if (addnew?.payload?.data?.error) {
        this.props.alert.setSnack("error");
        return false;
      } else {
        this.props.alert.setSnack("success");
      }
      await this.props.ORDERNATUREREAD();
      this.setState({
        openEditFrom: false,
        edit_data: null,
      });
      this.handleCloseForm();
    }
  };
  render() {
    const { open, openIndex } = this.props;
    return (
      <React.Fragment>
        <CommonTable
          style={{ height: "calc(100vh - 245px)" }}
          parent_id={"order_nature"}
          // handleEdit={this.handleEdit}
          Header={[
            "S.No",
            "Order Nature",
            "Short Description",
            "Long Description",
            "Status",
            "Action",
          ]}
          dataList={
            this.props?.OrderNature?.order_nature_read?.data
              ? this.props?.OrderNature?.order_nature_read?.data
              : []
          }
          tableData={[
            { type: ["INCRIMENT"], name: "" },
            { type: ["TEXT"], name: "code" },
            { type: ["TEXT"], name: "short" },
            { type: ["TEXT"], name: "long" },
            { type: ["CHECKBOX"], name: "status" },
            { type: ["EDIT"], name: "" },
          ]}
          handleCheckBox={this.statusChange}
          handleEdit={this.handleEdit}
        />
        <GenerateForm
          parent_id={"order_nature"}
          open={open && openIndex === 1}
          handlecancel={() => this.handleCloseForm()}
          header={
            this.state?.edit_data?._key
              ? "Edit Order Nature"
              : "Add New Order Nature"
          }
          nocancel
          save={this.saveOrderNature}
          json={[
            {
              componet_type: "text",
              label: "Order Nature Code",
              state_name: "order_nature",
              value: this.state?.edit_data?.code ?? "",
              required: true,
              isUpperCase: true,
              disabled: this.state?.edit_data?.code ? true : false,
              textLength: 20,
            },
            {
              componet_type: "text",
              label: "Short Description",
              state_name: "short_Description",
              value: this.state?.edit_data?.short ?? "",
              required: true,
            },
            {
              componet_type: "text",
              label: "Long Description",
              state_name: "long_Description",
              value: this.state?.edit_data?.long ?? "",
              required: true,
            },
          ]}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  OrderNature: state?.ordernatureSlice,
});

export default connect(
  mapStateToProps,
  actions
)(withAllContexts(withRouter(OrderNature)));
